<template>
	<div id="files">
		<div>
            <div class="row card mt-4" style="padding: 0px;">
				<div class="col-12 card-header bg-primary details" style="margin: 0px;">
					<h5>Files</h5>
				</div>
				<div class="card-body" style="padding: 20px;">
					<div v-if="createAccess">
						<div class="mb-4">
							<el-button @click.prevent="newFile()" type="success" size="default" >Upload New File</el-button>
						</div>
					</div>
					<h5>File Properties</h5>
					<el-input
							class="search"
							v-model="search"
							size="default"
							clearable
                            style="margin-right: 10px;"
							placeholder="Type to search"/>
					<el-button size="default" type="primary" @click="fileFilter">Search</el-button>
					<br>
					<div class="card">
						<strong>Search and Bulk Change Values</strong><br>
						<el-select key="select6" v-model="OrganizationIDs" style="width: 100%;max-width: 860px;" class="mb-1" size="default" placeholder="Clients" multiple default-first-option filterable clearable>
							<el-option
									v-for="item in Organizations"
									:label="item.OrganizationName"
									:value="item.OrganizationID"
									:key="item.OrganizationID">
							</el-option>
						</el-select>
						<br>
						<el-select key="select1" class="mb-1" size="default" style="width: 120px;margin-right: 10px;" v-model="bpm" placeholder="BPM" default-first-option filterable clearable>
							<el-option
									v-for="item in BPMs"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select2" class="mb-1" size="default" style="width: 200px;margin-right: 10px;" v-model="genre"  placeholder="Genre" default-first-option filterable clearable>
							<el-option
									v-for="item in Genres"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select3" class="mb-1" size="default" style="width: 200px;margin-right: 10px;" v-model="mood" placeholder="Mood" default-first-option filterable clearable>
							<el-option
									v-for="item in Moods"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select4" class="mb-1" size="default" style="width: 150px;margin-right: 10px;" v-model="format"  placeholder="Format" default-first-option filterable clearable>
							<el-option
									v-for="item in Formats"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
						<el-select key="select5" class="mb-1" size="default" style="width: 150px;margin-right: 10px;" v-model="length" placeholder="Length" default-first-option filterable clearable>
							<el-option
									v-for="item in Lengths"
									:key="item.FileSpecificationID"
									:label="item.SpecName"
									:value="item.FileSpecificationID">
							</el-option>
						</el-select>
                        <el-date-picker class="mb-1" v-model="postdate" size="default" default-first-option filterable clearable
                                        type="date"
                                        format="MMMM D, YYYY"
                                        value-format="YYYY-MM-DD"
                                        style="margin-right: 10px;"
                                        placeholder="Post Date">
                        </el-date-picker>
						<el-radio-group v-model="archived" size="default">
							<el-radio-button value="" selected>No Status Change</el-radio-button>
							<el-radio-button value="n">Active</el-radio-button>
							<el-radio-button value="y">Archived</el-radio-button>
							<el-radio-button value="h">Historical</el-radio-button>
						</el-radio-group>

						<el-button size="default" style="margin-left: 20px;margin-top: 5px;" type="warning" @click="bulkChangeCnfm">Bulk Change</el-button>
					</div>
					<el-table v-loading="loading" class="mt-1"
							  :data="PageFiles"
							  ref="tablefiles"
							  border
							  key="tablefiles"
							  size="small"
							  max-height="600"
							  empty-text="No Files"
							  stripe
							  @selection-change="handleSelectionChange"
                              @sort-change="sortFile"
							  style="width: 100%">
						<el-table-column
								type="selection"
								align="center"
								width="50"
						>
						</el-table-column>
                        <el-table-column type="expand">
                            <template #default="scope">
                                <span class="json" v-html="'<pre>'+scope.row.ParamsF+'</pre>'"></span>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="sample"
								label="Sample"
								align="center"
								width="70">
							<template #default="scope">
								<span v-if="scope.row.SampleURL">
									<i v-if="scope.row.samplePlaying == 'n'" class="fas fa-play-circle" @click="playSound(scope.row.SampleURL);scope.row.samplePlaying = 'y';"></i>
									<i v-else class="fas fa-pause-circle" @click="stopSound(scope.row.SampleURL);scope.row.samplePlaying = 'n';"></i>
								</span>
							</template>
						</el-table-column>
                        <el-table-column
                          prop="FileName"
                          label="Name"
                          min-width="120"
                          sortable="custom"
                        >
                          <template #default="scope">
                            <div v-html="scope.row.FileName" ></div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="ClientFileName"
                          label=" Client Name"
                          min-width="120"
                          sortable="custom"
                        >
                          <template #default="scope">
                            <div v-html="scope.row.ClientFileName" ></div>
                          </template>
                        </el-table-column>
						<el-table-column
								prop="TimeAgo"
								label="Uploaded"
								width="120"
                                sortable="custom"
						>
						</el-table-column>
						<el-table-column
								prop="filespecs"
								label="Properties"
								width="160"
						>
							<template #default="scope">
								<div v-if="scope.row.BPM" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">BPM: {{scope.row.BPM}}</div>
								<div v-if="scope.row.Mood" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Mood: {{scope.row.Mood}}</div>
								<div v-if="scope.row.Length" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Length: {{scope.row.Length}}</div>
								<div v-if="scope.row.Genre" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Genre: {{scope.row.Genre}}</div>
								<div v-if="scope.row.Format" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Format: {{scope.row.Format}}</div>
							</template>
						</el-table-column>
                        <el-table-column
                            prop="Size"
                            label="Size (mb)"
                            min-width="100"
                            align="center"
                            sortable="custom"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="Duration"
                            label="Duration"
                            min-width="100"
                            align="center"
                            sortable="custom"
                        >
                            <template #default="scope">
                                <span v-html="scope.row.DurationF"></span>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="OrganizationNames"
								label="Clients"
								min-width="120"
						>
							<template #default="scope">
								<span v-html="scope.row.OrganizationNames"></span>
							</template>
						</el-table-column>
						<el-table-column
							prop="Archived"
							label="Status"
							width="80"
							:filters="[{ text: 'Active', value: 'n' }, { text: 'Archived', value: 'y' }, { text: 'Historical', value: 'h' }]"
							:filter-method="filterStatus"
							filter-placement="bottom-end"
							:filtered-value="['n','y','h']"
					>
						<template #default="scope">
							<span v-html="(scope.row.Archived == 'y' ? 'Archived' : (scope.row.Archived == 'h' ? 'Historical' : 'Active'))"></span>
						</template>
					</el-table-column>
						<el-table-column v-if="modifyAccess"
										 label=""
										 width="100"
										 align="center">
							<template #default="scope">
								<a href="javascript:;" style="margin-right: 15px;" @click="editFile(scope.$index, scope.row)"><i class="fas fa-edit"></i></a>
								<a href="javascript:;" @click="deleteCnfm(scope.$index, scope.row)"><i class="far fa-trash-alt"></i></a>
							</template>
						</el-table-column>
						<el-table-column
								prop="file"
								label="Downloads"
								align="center"
								sortable
								:sort-method="sortDownloads"
								width="120"
						>
							<template #default="scope">
								<el-tooltip v-if="scope.row.DownloadCount" placement="top" effect="light">
									<div slot="content" v-html="scope.row.DownloadList"></div>
									<span style="cursor:pointer;" class="DownloadCount" v-html="scope.row.DownloadCount"></span>
								</el-tooltip>
								<el-button type="primary" size="small" @click="forceFileDownload(scope.row.FileID, scope.row.FullURL);" >Download</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							background
							:hide-on-single-page="singlePage"
							class="mt-4"
							:current-page.sync="currentPage"
							:page-sizes="[100, 500, 1000, 2000]"
							:page-size="100"
							layout="sizes, prev, pager, next"
							:total="count">
					</el-pagination>
          <audio ref="audioPlayer" :src="currentFile" autoplay="true" preload="none"
                 v-on:ended="stopSound()"></audio>
				</div>
	        </div>
		</div>
		<modal v-if="showModal" :showMask="false" @close="showModal = false" @refreshData="reset">
            <template v-slot:header>
                <h5  class="modal-title">
                    {{modalTitle}}
                </h5>
            </template>
			<template v-slot:body >
				<FileUploads ref="file" :fileData="modalData" :config="config" @refreshData="reset" />
			</template>
			<template v-slot:footer>
				<div v-html="modalFooter"></div>
			</template>
		</modal>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Modal from './global/Modal.vue';
	import FileUploads from './FileUploads.vue';
	import axios from 'axios';
    import Util from '../assets/js/util.js';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				loading: false,
				currentPage: 1,
				count: 0,
				sizePerPage: 100,
				singlePage : false,
				Files: [],
				FilteredFiles: [],
				PageFiles : [],
				search : '',
				showModal : false,
				modalTitle: 'Edit File',
				modalFooter: '&nbsp;',
				currentStatus : 0,
				currentFile : '',
				file : {},
				samplePlaying : 'n',
				bpm : '',
				genre : '',
				mood : '',
				format :'',
				length : '',
				archived : '',
				postdate : '',
				OrganizationIDs : [],
				BPMs : [],
				Genres : [],
				Moods : [],
				Formats : [],
				Lengths: [],
				Organizations : [],
				multipleSelection : [],
                sortProp : '',
                sortOrder : ''
			}
		},
		name: 'Files',
		components: {
			Modal,
			FileUploads
		},
		props: {
			config : { type: Object },
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
	        createAccess () {
                return Util.createAccess(this.currentUser);;
            },
	        modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
		},
		methods: {
			handleSelectionChange (selection) {
				this.multipleSelection = selection;
			},
			filterStatus(value, row) {
				return row.Archived === value;
			},
			handleSizeChange(val) {
				this.sizePerPage = val;
				this.pageFilter();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.pageFilter();
			},
			pageFilter () {
				this.PageFiles = [];
				let start = (this.currentPage-1) * this.sizePerPage;
				for (let i=0; i < this.FilteredFiles.length; i++) {
					if (i >= start && this.PageFiles.length < this.sizePerPage) {
						this.PageFiles.push(this.FilteredFiles[i]);
					}
				}
				if (start == 0 && this.PageFiles.length < this.sizePerPage) {
					this.singlePage = true;
				} else {
					this.singlePage = false;
				}
			},
			fileFilter() {
				var goodFiles = [];
				var count = 0;
				for (let i=0; i < this.Files.length; i++) {
					var includeFile = true;

          if (this.search && !this.Files[i].FileName.toLowerCase().includes(this.search.toLowerCase())) {
            includeFile = false;
          }
                if (this.bpm && this.bpm != this.Files[i].BPMID) {
                    includeFile = false;
                }
                if (this.genre && this.genre != this.Files[i].GenreID) {
                    includeFile = false;
                }
                if (this.mood && this.mood != this.Files[i].MoodID) {
                    includeFile = false;
                }
                if (this.format && this.format != this.Files[i].FormatID) {
                    includeFile = false;
                }
                if (this.length && this.length != this.Files[i].LengthID) {
                    includeFile = false;
                }
                if (this.archived && this.archived != this.Files[i].Archived) {
                    includeFile = false;
                }

                if (includeFile && this.OrganizationIDs.length > 0) {
                    let orgFound = false;
                    for (let j=0; j < this.OrganizationIDs.length; j++) {
                        if (this.Files[i].OrganizationIDs.indexOf(this.OrganizationIDs[j]) !== -1) {
                            orgFound = true;
                            break;
                        }
                    }
                    includeFile = orgFound;
                }
                if (includeFile) {
                    goodFiles.push(this.Files[i]);
                }
            }
            this.FilteredFiles = goodFiles;
            this.count = this.FilteredFiles.length;
            this.currentPage = 1;
            this.pageFilter();
        },
      sortFile(data) {
          if (data.prop == 'TimeAgo') {
              data.prop = 'TimeAgoSort';
          }
          this.sortProp = data.prop;
          this.sortOrder = data.order;
          this.Files.sort(function(a, b) {
              if (data.prop == 'Duration' || data.prop == 'Size') {
                  if (data.order == 'ascending') {
                      var labelA = parseInt(a[data.prop].toString().toLowerCase().trim()),
                          labelB = parseInt(b[data.prop].toString().toLowerCase().trim());
                  } else {
                      var labelB = parseInt(a[data.prop].toString().toLowerCase().trim()),
                          labelA = parseInt(b[data.prop].toString().toLowerCase().trim());
                  }
                  var result = labelA - labelB;

                  return result;
              } else {
                  if (data.order == 'ascending') {
                      var labelA = a[data.prop].toString().toLowerCase().trim(),
                          labelB = b[data.prop].toString().toLowerCase().trim();
                  } else {
                      var labelB = a[data.prop].toString().toLowerCase().trim(),
                          labelA = b[data.prop].toString().toLowerCase().trim();
                  }
                  if (labelA < labelB) { //sort string ascending
                      return -1;
                  } else if (labelA > labelB) {
                      return 1
                  } else {
                      return 0 //default return value (no sorting)
                  }
              }
          });
        this.fileFilter();
      },
      playSound(file) {
        if (this.currentFile) {
          this.stopSound();
        }
        this.currentFile = file;
        this.audio = this.$refs.audioPlayer;
        var playPromise = this.audio.play();

        if (playPromise !== undefined) {
          playPromise.then(_ => {
          })
            .catch(error => {

            });
        }
      },
      stopSound() {
        this.currentFile = '';
        for (let i=0; i < this.PageFiles.length; i++) {
          this.PageFiles[i]['samplePlaying'] = 'n';
        }
        this.audio = this.$refs.audioPlayer;

        var playPromise = this.audio.pause();

        if (playPromise !== undefined) {
          playPromise.then(_ => {
          })
            .catch(error => {

            });
        }
      },
			sortDownloads (a,b) {
				return parseInt(a.DownloadCount) - parseInt(b.DownloadCount);
			},
            forceFileDownload(FileID, FullURL){
                axios.post('/files/downloadonly', {FileID : FileID}
                )
                    .then(response => {
                        if (response.data.result == 'success') {
                            const link = document.createElement('a');
                            link.href = response.data.FileURL;
                            var filename = FullURL.replace(/^.*[\\\/]/, '')
                            link.setAttribute('download', filename) //or any other extension
                            document.body.appendChild(link);
                            link.click();
                        } else {
                            this.$notify({
                                title: 'Error',
                                message: "File cannot be Downloaded",
                                type: 'error',
                                duration: 2000,
                                showClose: false
                            });
                        }
                    }).catch(response => {
                });
            },
			reset(showMessage) {
				// reset form to initial state
				this.showModal = false;
				this.currentStatus = STATUS_INITIAL;
				this.getInitialData ();

				if (showMessage) {
					this.$notify({
						title: 'Success',
						message: 'Data has been reset',
						type: 'success',
						duration: 1500,
						showClose: false
					});
                 }
			},
			getInitialData () {
				var tables = ['BPMs','Genres','Moods','Lengths','Formats','Organizations'];
				axios.post('/index/tableData', {'tables': tables },
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
							this.getAllFiles();
						} else {
						}
					}).catch(response => {
				});
			},
			getAllFiles() {
				this.loading = true;
				axios.post('/files/getall', {},
				)
					.then(response => {
						if (response.data.result == 'success') {
                            for (let i = 0; i < response.data.Files.length; i++) {
                                response.data.Files[i].ParamsF = JSON.stringify(response.data.Files[i].Params, null, '\t');
                            }
							this.Files = response.data.Files;
							this.fileFilter();
							if (this.sortProp) {
                                this.$refs['tablefiles'].sort(this.sortProp, this.sortOrder);
                            };
						} else {
						}
						this.loading = false;
					}).catch(response => {
						this.loading = false;
				});
			},
			editFile(index, row) {
				this.modalTitle = 'Edit File';
				this.modalData = row;
				this.displayModal();
			},
			newFile() {
				this.modalTitle = 'Upload New File';
				this.modalData = {FileID : 0};
				this.displayModal();
			},
			displayModal () {
				this.showModal = true;
			},
			hideModal () {
				this.showModal = false;
			},
			bulkChangeCnfm() {
				if (this.multipleSelection.length > 0) {
					this.$confirm('You are about to bulk edit ' + this.multipleSelection.length + ' files. Continue?', 'Warning', {
						confirmButtonText: 'OK',
						cancelButtonText: 'Cancel',
						type: 'warning'
					}).then(() => {
						this.bulkSave();
					}).catch(() => {
					});
				}
			},
			bulkSave () {
				axios.post('/files/bulksave', {'Files': this.multipleSelection, OrganizationIDs :  this.OrganizationIDs, GenreID : this.genre, MoodID : this.mood, BPMID : this.bpm, FormatID : this.format, LengthID : this.length, Archived : this.archived, PostDate : this.postdate }
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.$refs.tablefiles.clearSelection();
							this.getAllFiles();
							this.$notify({
								title: 'Success',
								message: "Files have been successfully saved.",
								type: 'success',
								duration: 1500,
								showClose: false
							});
						} else {
							this.$notify({
								title: 'Error',
								message: "Files could not be saved.",
								type: 'error',
								duration: 2000,
								showClose: false
							});
						}
					}).catch(response => {
					this.$notify({
						title: 'Error',
						message: "Files could not be saved.",
						type: 'error',
						duration: 2000,
						showClose: false
					});
				});
			},
			deleteCnfm (index,row) {
				this.$confirm('Are you sure you wish to delete this file?', 'Confirmation', {
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
					type: 'warning',
					showClose: false,
					showCancelButton: true
				}).then(() => {
					this.deleteFile(index, row);
				}).catch(() => {
				});

			},
			deleteFile(index, row) {
				axios.post('/files/delete', {'FileID': row.FileID}
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.getAllFiles();
							this.$notify({
								title: 'Success',
								message: "File has been deleted",
								type: 'success',
								duration: 1500,
								showClose: false
							});
						} else {
							this.$notify({
								title: 'Error',
								message: "File cannot be deleted",
								type: 'error',
								duration: 2000,
								showClose: false
							});
						}
					}).catch(response => {
					this.$notify({
						title: 'Error',
						message: "File cannot be deleted",
						type: 'error',
						duration: 2000,
						showClose: false
					});
				});
			},
	        displayPopup (message) {
				this.$alert(message,  {
					type: 'error',
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {

			this.getInitialData();
		},
	}
</script>
<style>
	#files .el-table th>.cell.highlight {
		color: #fff;
		font-weight: 800;
	}
	#files .el-table__column-filter-trigger i {
		color: #fff;
		font-weight: 800;
	}
	#files .card {
		display: block;
	}
</style>
<style scoped>

	.el-select {
		width: 50%;
	}
	table thead tr th:last-child {
		text-align: center;
	}
	.id {
		padding-top: 6px;
	}
	.delete{
		padding-top: 10px;
	}
	.el-input.Value, .el-input.Name {
		width: 40%;
		margin-bottom: 5px;
	}
	.el-input.Sort {
		width: 10%;
		margin-bottom: 5px;
		text-align:center;
	}
	.heading.Value, .heading.Name {
		width: 40%;
		margin-bottom: 5px;
		text-align: center;
		display: inline-block;
	}
	.heading.Sort {
		width: 10%;
		margin-bottom: 5px;
		text-align: center;
		display: inline-block;
	}
	i.fas {
		font-size: 20px;
		cursor:pointer;
	}
	.search {
		margin-bottom: 5px;
		width: 45%;
	}
	a i {
		font-size: 20px;
		font-weight: 800;
	}
	.Archived {
		color: #DC3545;
	}
	.DownloadCount {
		color: #DC3545;
		font-size: 14px;
		font-weight: 800;
	}
</style>
